export const INVOICE_NUMBER_TEMPLATE_LIST_URL = '/admin/templates/invoice-numbers-templates';
export const INVOICE_NUMBER_TEMPLATE_ADD_URL = '/admin/templates/invoice-numbers-templates/add';
